<template>
  <div v-on-clickaway="closeAddLabels" class="relative">
    <div
      class="nav-action-item flex items-center gap-1 p-1 rounded-[5px] hover:bg-gray-100 transition-colors cursor-pointer outline-none border-0 bg-transparent"
      @click="toggleAddLabels"
      @keyup.esc="closeAddLabels"
    >
      <div class="flex items-center gap-[5px]">
        <span
          class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
        >
          shoppingmode
        </span>
        <div class="flex items-center gap-[2px]">
          <template v-if="activeLabels.length">
            <woot-label
              :key="activeLabels[0].id"
              :title="activeLabels[0].title"
              :description="activeLabels[0].description"
              :color="activeLabels[0].color"
              class="!mr-0"
              small
            />
            <woot-label
              v-if="activeLabels.length > 1"
              :key="'label-more'"
              :title="moreLabels"
              variant="tag-mute-01"
              small
            />
          </template>
          <span v-else class="text-sm text-gray-600">{{
            $t('CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_LABELS')
          }}</span>
        </div>
      </div>
      <span
        class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
      >
        expand_more
      </span>
    </div>
    <dropdown-panel
      v-if="isOpenSelector"
      :items="accountLabels"
      :selected-items="savedLabels"
      selected-key="title"
      :searchable="searchable"
      :search.sync="search"
      :search-keys="['title']"
      :no-result-text="$t('CONTACT_PANEL.LABELS.LABEL_SELECT.NO_RESULT')"
      :placeholder="$t('CONTACT_PANEL.LABELS.LABEL_SELECT.PLACEHOLDER')"
      @select="onSelectLabel"
    >
      <template #header="{ filteredItems }">
        <div
          v-if="hasCreatePermission('Labels')"
          class="gap-1 button-naked dropdown-item new-label-btn"
          :class="{ disabled: hasExactMatch(filteredItems) }"
          @click.prevent="addNewLabel(filteredItems)"
        >
          <span class="material-symbols-outlined text-[24px]">add</span>
          <span>New label</span>
        </div>
      </template>
      <template #item="{ item }">
        <div class="w-[24px] h-[24px] p-[3.5px]">
          <span
            class="w-full h-full block rounded-[2px]"
            :style="`background: ${item.color}`"
          />
        </div>
        <span class="my-[3px]">{{ item.title }}</span>
      </template>
    </dropdown-panel>
    <woot-modal :show.sync="createModalVisible" :on-close="hideCreateModal">
      <add-label-modal :prefill-title="parsedSearch" @close="hideCreateModal" />
    </woot-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import conversationLabelMixin from 'dashboard/mixins/conversation/labelMixin';
import { sanitizeLabel } from 'shared/helpers/sanitizeData';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import AddLabelModal from 'dashboard/routes/dashboard/settings/labels/AddLabel.vue';
import DropdownPanel from './DropdownPanel.vue';

export default {
  components: { AddLabelModal, DropdownPanel },
  mixins: [clickaway, conversationLabelMixin, hasPermissionMixin],
  props: {
    searchable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpenSelector: false,
      conversationId: this.currentChat?.id,
      search: '',
      createModalVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentChat: 'getSelectedChat',
    }),
    moreLabels() {
      return `+${this.activeLabels.length - 1}`;
    },
    parsedSearch() {
      return sanitizeLabel(this.search);
    },
  },
  watch: {
    currentChat(value) {
      this.conversationId = value.id;
    },
  },
  methods: {
    toggleAddLabels() {
      this.isOpenSelector = !this.isOpenSelector;
    },
    closeAddLabels() {
      this.isOpenSelector = false;
    },
    onSelectLabel(label) {
      if (this.savedLabels.includes(label.title)) {
        this.removeLabelFromConversation(label.title);
      } else {
        this.addLabelToConversation(label);
      }
    },
    hasExactMatch(filteredItems) {
      return filteredItems.some(label => label.title === this.search);
    },
    addNewLabel(filteredItems) {
      if (this.hasExactMatch(filteredItems)) return;
      this.createModalVisible = true;
    },
    hideCreateModal() {
      this.createModalVisible = false;
    },
    // handleKeyEvents(e) {
    //   const keyPattern = buildHotKeys(e);

    //   if (keyPattern === 'l' && !isActiveElementTypeable(e)) {
    //     this.toggleAddLabels();
    //     e.preventDefault();
    //   } else if (isEscape(e) && this.showSearchDropdownLabel) {
    //     this.closeAddLabels();
    //     e.preventDefault();
    //   }
    // },
  },
};
</script>
